import React from 'react';
import { IconProps } from '../types/types';

const ZENT: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><circle cx="10" cy="10" r="10" fill="#5724FF"/><path d="m9.793 12.179-.572-3.117-4.676 7.188 11.705-4.071H9.793Z" fill="#fff"/><path d="m10.207 7.821.572 3.117 4.676-7.188L3.75 7.821h6.457Z" fill="#fff"/></svg>
);

export default ZENT;
